module.exports = __webpack_public_path__ + "static/media/advisor-2@2x.5a7a988c.jpg";